import ticketStatus5 from '../../../../assets/images/serviceOrderStatuses/ticket-5.svg'
import guaranteeRepairIcon from '../../../../assets/images/serviceOrderStatuses/guaranteeRepair.svg'
import repairIsDoneIcon from '../../../../assets/images/serviceOrderStatuses/repairIsDone.svg'

export const getTicketIconSrc = (id) => {
  switch (id) {
    case 2:
      return repairIsDoneIcon

    case 5:
      return guaranteeRepairIcon

    case 4:
      return ticketStatus5
  }
}
